import { useState, useCallback } from 'react';
import { FileType } from 'shared/enums/FileType';
import { v4 as uuidv4 } from 'uuid';
type UploadingFilesProps = {
  file: File;
  id: string;
};

export const useEditProfileUploadingFiles = (fileType: FileType) => {
  // Files is dropped on here
  const [uploadedFiles, setUploadedFiles] = useState<UploadingFilesProps[]>([]);

  const handleSetUploadedFiles = useCallback((files: File[]) => {
    // Because Image Section not using this
    if (fileType === FileType.IMAGE) return;
    // ID is needed to prevent infinite loop if the EditProfileMediaUploadingItem  is being used
    const newFiles = files.map((file) => ({
      file: file,
      id: uuidv4(),
    }));
    setUploadedFiles((prev) => [...prev, ...newFiles]);
  }, []);

  const handleRemoveUploadedFiles = useCallback((id: string) => {
    setUploadedFiles((prev) => prev.filter((p) => p.id !== id));
  }, []);

  return { uploadedFiles, handleSetUploadedFiles, handleRemoveUploadedFiles };
};
